import type { DarkModeState } from "../atoms/dark-mode.atom";

export const darkModeThemeColors: Record<DarkModeState, string> = {
  light: "#f9fafb",
  dark: "#111827",
};

/**
 * Check whether an untrusted value is a supported persisted dark-mode state.
 *
 * @example
 * isDarkModeState("dark"); // true
 */
export function isDarkModeState(value: unknown): value is DarkModeState {
  return value === "light" || value === "dark";
}

/**
 * Resolve an untrusted persisted value to the app's supported dark-mode state.
 *
 * @example
 * resolveDarkModePreference("system"); // "light"
 */
export function resolveDarkModePreference(value: unknown): DarkModeState {
  return isDarkModeState(value) ? value : "light";
}
